import _toConsumableArray from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { localList } from './lang.js';
import { array as baseList } from 'badwords-list';
/**
 * Profanity Filter class.
 * @public
 */
export var Filter = /*#__PURE__*/function () {
  /**
   * Filter constructor.
   *
   * @param {FilterOptions} options - Constructor options for Filter class.
   */
  function Filter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Filter);
    /**
     * List of words to filter.
     * @type {array} list - List of words to filter.
     */
    _defineProperty(this, "list", []);
    /**
     * List of words to exclude from filter.
     * @type {array} exclude - List of words to exclude from filter.
     */
    _defineProperty(this, "exclude", []);
    /**
     * Character used to replace profane words.
     * @type {string} placeHolder - Character used to replace profane words.
     */
    _defineProperty(this, "placeHolder", '*');
    /**
     * Regular expression used to sanitize words before comparing them to blocklist.
     * @type {string} regex - Regular expression used to sanitize words before comparing them to blocklist.
     */
    _defineProperty(this, "regex", /[^a-zA-Z0-9|$|@]|\^/g);
    /**
     * Regular expression used to replace profane words with placeHolder.
     * @type {string} replaceRegex - Regular expression used to replace profane words with placeHolder.
     */
    _defineProperty(this, "replaceRegex", /\w/g);
    /**
     * Regular expression used to split a string into words.
     * @type {string} splitRegex - Regular expression used to split a string into words.
     */
    _defineProperty(this, "splitRegex", /\b|_/g);
    Object.assign(this, {
      list: options.emptyList && [] || Array.prototype.concat.apply(localList, [baseList, options.list || []]),
      exclude: options.exclude || [],
      splitRegex: options.splitRegex || /\b|_/g,
      placeHolder: options.placeHolder || '*',
      regex: options.regex || /[^a-zA-Z0-9|$|@]|\^/g,
      replaceRegex: options.replaceRegex || /\w/g
    });
  }
  /**
   * Determine if a string contains profane language.
   * @param {string} string - String to evaluate for profanity.
   */
  _createClass(Filter, [{
    key: "isProfane",
    value: function isProfane(string) {
      var _this = this;
      return this.list.filter(function (word) {
        var wordExp = new RegExp("\\b".concat(word.replace(/(\W)/g, '\\$1'), "\\b"), 'gi');
        return !_this.exclude.includes(word.toLowerCase()) && wordExp.test(string);
      }).length > 0 || false;
    }
    /**
     * Replace a word with placeHolder characters;
     * @param {string} string - String to replace.
     */
  }, {
    key: "replaceWord",
    value: function replaceWord(string) {
      return string.replace(this.regex, '').replace(this.replaceRegex, this.placeHolder);
    }
    /**
     * Evaluate a string for profanity and return an edited version.
     * @param {string} input - String to filter.
     */
  }, {
    key: "clean",
    value: function clean(input) {
      var _this2 = this;
      var delimiter = this.splitRegex.exec(input);
      if (!input || !delimiter) {
        return input;
      }
      return input.split(this.splitRegex).map(function (word) {
        return _this2.isProfane(word) ? _this2.replaceWord(word) : word;
      }).join(delimiter[0]);
    }
    /**
     * Add word(s) to blocklist filter / remove words from whitelist filter
     * @param {...string} words - Word(s) to add to blocklist
     */
  }, {
    key: "addWords",
    value: function addWords() {
      var _this$list,
        _this3 = this;
      for (var _len = arguments.length, words = new Array(_len), _key = 0; _key < _len; _key++) {
        words[_key] = arguments[_key];
      }
      (_this$list = this.list).push.apply(_this$list, words);
      words.map(function (word) {
        return word.toLowerCase();
      }).forEach(function (word) {
        if (_this3.exclude.includes(word)) {
          _this3.exclude.splice(_this3.exclude.indexOf(word), 1);
        }
      });
    }
    /**
     * Add words to allowlist filter
     * @param {...string} words - Word(s) to add to allowlist.
     */
  }, {
    key: "removeWords",
    value: function removeWords() {
      var _this$exclude;
      for (var _len2 = arguments.length, words = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        words[_key2] = arguments[_key2];
      }
      (_this$exclude = this.exclude).push.apply(_this$exclude, _toConsumableArray(words.map(function (word) {
        return word.toLowerCase();
      })));
    }
  }]);
  return Filter;
}();